export default {
    en: {
        title: "PM AUTOTWIN",
        nav_title: "PM AUTOTWIN",
        beta: "BETA",
        beta_info: "PM AutoTwin Beta",

        pm_copyright: "© 2026 Pocket Memory Co.,Ltd. All Rights Reserved",
        term_of_user_login_btn: "Terms of Service & Privacy Policy",
        terms_of_service: "Terms of Service",
        privacy_policy: "Privacy Policy",
        terms_privacy_separator: " & ",

        name: "Full Name",
        company: "Company",

        nav_optimize: "Optimize",
        nav_dashboard: "Dashboard",
        nav_my_plan: "My Plan",

        ok: "OK",
        cancel: "Cancel",
        delete: "Delete",
        loading: "Loading...",
        share_link_copied: "Share link copied",

        get_more_credits: "Get More Credits",
    },
    ko: {
        title: "PM AUTOTWIN",
        nav_title: "PM AUTOTWIN",
        beta: "BETA",
        beta_info: "PM AutoTwin 베타 테스트 버전입니다",

        pm_copyright: "© 2026 Pocket Memory Co.,Ltd. All Rights Reserved",
        term_of_user_login_btn: "이용약관 및 개인정보처리방침",
        terms_of_service: "이용약관",
        privacy_policy: "개인정보처리방침",
        terms_privacy_separator: " 및 ",

        name: "이름",
        company: "회사명",


        nav_optimize: "최적화",
        nav_dashboard: "대시보드",
        nav_my_plan: "마이플랜",

        ok: "확인",
        cancel: "취소",
        delete: "삭제",
        loading: "로딩 중...",
        share_link_copied: "공유 링크가 복사되었습니다",

        get_more_credits: "추가 크레딧 받기",
    },
    ja: {
        title: "PM AUTOTWIN",
        nav_title: "PM AUTOTWIN",
        beta: "BETA",
        beta_info: "PM AutoTwinのベータテストへようこそ",

        pm_copyright: "© 2026 Pocket Memory Co.,Ltd. All Rights Reserved",
        term_of_user_login_btn: "利用規約とプライバシーポリシー",
        terms_of_service: "利用規約",
        privacy_policy: "プライバシーポリシー",
        terms_privacy_separator: "と",

        name: "名前",
        company: "会社名",


        nav_optimize: "最適化",
        nav_dashboard: "ダッシュボード",
        nav_my_plan: "マイプラン",

        ok: "確認",
        cancel: "キャンセル",
        delete: "削除",
        loading: "読み込み中...",
        share_link_copied: "共有リンクがコピーされました",

        get_more_credits: "追加クレジットを受け取る",
    },
};
